package games.polyclub.website.frontend.store.components

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.frontend.lib.react.utils.useEffectOnceAsync
import games.polyclub.website.frontend.store.appScope
import games.polyclub.website.frontend.store.hooks.useAuth
import games.polyclub.website.frontend.store.hooks.useRefreshToken
import jquery.jQuery
import react.Props
import react.router.Outlet
import react.useEffect
import react.useState
import web.timers.clearTimeout
import web.timers.setTimeout
import kotlin.time.Duration.Companion.milliseconds

val PersistentLogin = SFC<Props> { _ ->
    val (isLoading, setIsLoading) = useState(true)
    val (usePreloader, setUsePreloader) = useState(false)
    val refresh = useRefreshToken()
    val ctx = useAuth()

    useEffect {
        jQuery("#wrapper, body, html").removeClass("forced_height_100 img_in_middle")
    }

    useEffect(isLoading, usePreloader) {
        if (isLoading && !usePreloader) {
            jQuery("#wrapper").addClass("forced_height_100 img_in_middle")
            jQuery("#wrapper, html, body").addClass("forced_height_100")
        } else {
            jQuery("#wrapper").removeClass("forced_height_100 img_in_middle")
            jQuery("html, body").removeClass("forced_height_100")
        }
        cleanup {
            jQuery("#wrapper").removeClass("img_in_middle")
            jQuery("#wrapper, html, body").removeClass("forced_height_100")
        }
    }

    appScope.useEffectOnceAsync {
        var isMounted = true
        setUsePreloader(false)
        val timer = setTimeout(10.milliseconds) {
            if (isMounted && isLoading) {
                setUsePreloader(true)
            }
        }

        suspend fun verifyRefreshToken() {
            try {
                refresh()
            } finally {
                if (isMounted) {
                    setIsLoading(false)
                }
            }
        }

        if (ctx.auth?.accessToken == null) {
            verifyRefreshToken()
        } else {
            setIsLoading(false)
        }

        cleanup {
            isMounted = false
            clearTimeout(timer)
        }
    }

    if (!isLoading) {
        Outlet()
    } else if (!usePreloader) {
        img {
            alt = "Autenticando..."
            src = "/img/loading.svg"
            width = 200.0
            height = 200.0
        }
    } else {
        div("fixed-preloader hold-transition flex-column justify-content-center align-items-center") {
            img("animation__shake") {
                src = "/img/logo.png"
                alt = "Autenticando.."
                height = 102.0
                width = 661.0
            }
        }
    }
}
